import React, { FC, MouseEventHandler } from 'react';
import styled from '@xstyled/styled-components';
import Icon from '../../../../../../assets/icons/arrow-order.svg';
import { t } from 'ttag';

const StyledButton = styled.buttonBox<{ disabled?: boolean }>`
  min-width: 24px;
  min-height: 24px;
  background-color: ${p =>
    p.disabled ? p.theme.colors.greyMed : p.theme.colors.accentDark};
  cursor: ${p => (p.disabled ? 'initial' : 'pointer')};
  border-radius: 50%;
`;

const ArrowUp = styled(Icon)<{ title: string }>`
  transform: rotate(180deg);
`;

export const QuizOrderButtonUp: FC<{
  disabled?: boolean;
  onClickHandler: MouseEventHandler;
}> = ({ disabled, onClickHandler }) => {
  return (
    <StyledButton
      disabled={disabled}
      onClick={onClickHandler}
      aria-label={t`Move the item up`}
    >
      <ArrowUp title={t`Arrow up`} />
    </StyledButton>
  );
};
